import React,{useState} from 'react'
 import '../css/contact.css'
 function ContactUs() {

  return (
    <div  class="p-3  d-flex justify-content-center align-items-center bg-white " id="contact">
      <div class=" contact g-5 row shadow-lg rounded-5 bg-white mx-4 my-5">
        <div class=" col-md-6 ">
        <div class="ms-4 mt-4"> 
      <p  class=" fs-1 text-black">Get In Touch  </p>
        </div>
        <form class="row g-2  p-4"  role="form" action="https://formsubmit.co/apexdatatechnologies@gmail.com" method="POST" onsubmit="true" >
  <div class="col-md-12">
    <input type="text" class="form-control border-color-black"  name="name" placeholder='Name'  required/>  
  </div>
  <div class="col-md-12">
    <input type="email" class="form-control "  name="email"  placeholder='E-mail'  required/>
  </div>
  <div class="col-md-12"> 
    <input type="text" class="form-control" name="subject"  placeholder='subject' required/> 
  </div>
  <div class="col-md-12"> 
    <textarea class = "form-control"  name="message" placeholder='Message'rows = "8"></textarea>  
  </div>
  <input type="hidden" name="_next" value="http://adtindia.in/"/>
  <div class="col-12 ">
    <button class="btn btn-dark btn-lg my-3" type="submit" >Send Message</button>
  </div>
       </form>
        </div>
    <div class=" col-md-6 bg-transparent  d-flex justify-content-center align-items-center">
<div class=" m-2 ">
      <div>
      <p  class=" fs-1   text-black my-3 ">Don't hesitate to <br/> contact us.</p>
      </div>
        <div>
          <p  class=" fs-6    text-black "> Call Us </p>
          <p  class=" fs-5    text-black ">  <i class="  fa-solid fa-phone text-dark "></i> +91 9995885561</p>
          {/* <p  class=" fs-5 fw-bold  font-monospace text-black ">  <i class="  fa-solid fa-phone text-dark "></i> +91 ------------</p> */}
         </div>
         <div>
          <p  class=" fs-6   text-black "> Write to Us</p>
          <p  class=" fs-5    text-black "><i class="  fa-solid fa-envelope text-dark "></i> apexdatatechnologies@gmail.com</p>
         </div>
         <div>
          <p  class=" fs-6   text-black "> Office hours </p>
          <p  class=" fs-6   text-black "> <i class="  fa-solid fa-calendar-days text-dark "></i> Mon-sat  10:00-05:00 </p>
         </div>
</div>
    </div >    
     </div>
    </div>
  )
}
export default ContactUs